import Vue from 'vue';
import VueRouter from 'vue-router';
import App1Layout from '../app-component/route.js';
import App2Layout from '../app-independent/route.js'
const EmptyParentComponent = { template: "<router-view></router-view>" };

Vue.use(VueRouter);


const routes = [
    {
        path: '*',
        redirect: {
            // REdirecting to App1 layout
            name: 'page-not-found'
        },
    },
    {
        path: "/",
        redirect: {
            path: "app2"
        }
    },
    {
        path: "/oops",
        component: EmptyParentComponent,
        children: [
            {
                path: "page-not-found",
                name: "page-not-found",
                component: () => import(/* webpackChunkName: "oops-page-not-found" */ '@/helper.modules/PageNotFound/PageNotFound.vue'),
            },
            {
                path: "session-expired",
                name: "invalid-session",
                component: { template: "<h1>Session is expired</h1>" }
            }
        ]
    },
    App1Layout,
    App2Layout
]

export default new VueRouter({ routes });